<template>
  <div class="product-donate-type-wrapper" v-if="product && allowedMonthly">
    <div class="product-donate-type">
      <div class="donate-type-item">
        <div class="control">
          <input type="radio" name="donate_type" v-model="type" value="onetime"/>
          <label class="label label--left onetime">บริจาคครั้งเดียว</label>
        </div>
      </div>
      <div class="donate-type-item">
        <div class="control">
          <input type="radio" name="donate_type" v-model="type" value="monthly"/>
          <label class="label label--right monthly">บริจาคเป็นรายเดือน</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductDonateType',

    props: {
      product: {
        type: Object,
        default: null
      },
      value: {
        type: String,
        default: 'monthly'
      }
    },

    data () {
      return {
        type: this.value
      }
    },

    computed: {
      allowedMonthly () {
        return this.product.meta.$donation_allow_recurring_donation === true || this.product.meta.$donation_allow_recurring_donation === 'true'
      }
    },

    watch: {
      type: function (newValue) {
        this.$emit('input', newValue)
      },
      value: function (newValue) {
        this.type = newValue
      }
    }
  }
</script>

<style scoped lang="scss">
  .product-donate-type-wrapper {

    margin-bottom: 20px;

    .product-donate-type {
      display: flex;
      display: -webkit-flex;

      .donate-type-item {
        flex: 1;
        font-weight: 400;
        font-size: 0.85em;
        line-height: 1.5em;
      }
    }

    .control {
      position: relative;

      .label {
        color: #305E95;
        background: #fff;
        min-height: 40px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border: 2px solid #1E416D;

        &--left {
          border-right: 0;
          -webkit-border-top-left-radius: 23px;
          -webkit-border-bottom-left-radius: 23px;
          -moz-border-radius-topleft: 23px;
          -moz-border-radius-bottomleft: 23px;
          border-top-left-radius: 23px;
          border-bottom-left-radius: 23px;
        }

        &--right {
          border-left: 0;
          -webkit-border-top-right-radius: 23px;
          -webkit-border-bottom-right-radius: 23px;
          -moz-border-radius-topright: 23px;
          -moz-border-radius-bottomright: 23px;
          border-top-right-radius: 23px;
          border-bottom-right-radius: 23px;
        }
      }

      input[type="radio"] {
        cursor: pointer;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 999;
        opacity: 0;

        &:checked + .label {
          z-index: 1;
          background: #1E416D;
          color: #fff;
          -moz-box-shadow: inset 0 0 8px rgba(0, 0, 0, .3);
          -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, .3);
          box-shadow: inset 0 0 8px rgba(0, 0, 0, .3);
        }
      }
    }
  }

  @media (min-width: 360px) {
    .product-donate-type-wrapper {
      .product-donate-type {
        .donate-type-item {
          font-size: 1em;
        }
      }
    }
  }

  @media (min-width: 425px) {
    .product-donate-type-wrapper {
      .control {
        .label {
          &:before {
            // content: " ";
            // background: url("../assets/img/ic-onetime-gray@2x.png") no-repeat left center;
            // background-size: 100%;
            // width: 25px;
            // height: 25px;
            // margin-right: 10px;
          }
        }

        // .onetime:before { background: url("../assets/img/ic-onetime-gray@2x.png") no-repeat left center; background-size: 100%;}
        // .monthly:before { background: url("../assets/img/ic-monthly-gray@2x.png") no-repeat left center; background-size: 100%;}

        input[type="radio"]:checked + .label {
          &:before {
            // content: " ";
            // background: url("../assets/img/ic-onetime-white@2x.png") no-repeat left center;
            // background-size: 100%;
          }
        }

        // input[type="radio"]:checked + .onetime:before { background: url("../assets/img/ic-onetime-white@2x.png") no-repeat left center; background-size: 100%;}
        // input[type="radio"]:checked + .monthly:before { background: url("../assets/img/ic-monthly-white@2x.png") no-repeat left center; background-size: 100%;}
      }

    }
  }

</style>



// WEBPACK FOOTER //
// ProductDonateType.vue?768fd9e3